window.addEventListener('load', function(event) { 
    let items = document.querySelectorAll('.accordion__item');
    items.forEach(item => {
        item.addEventListener('click', slideAnim.bind(this));
        item.addEventListener('keydown', (event) => {
            if (event.code.toUpperCase() === 'SPACE' || event.code.toUpperCase() === 'ENTER') {
                slideAnim(event);
            }
        });
    })

    function slideAnim(e) {
        let el = e.currentTarget;
        let body = el.querySelector('.accordion__body');
        let allActiveAccordions = document.querySelectorAll('.accordion__item.accordion__item--active');
        let active = el.closest('.faq__content').querySelector('.accordion__item.accordion__item--active');
        // if (this.active) {
        //   this.active.classList.remove('accordion__item--animate');
        //   this.active.querySelector('.accordion__body').style.height = "0px";
        //   this.active.querySelector('.accordion__body').addEventListener('transitionend', () => {
        //     this.active.classList.remove('accordion__item--active')
        //   }, { once: true })
        // }
        if (!el.classList.contains('accordion__item--active')) {
            Array.from(allActiveAccordions).forEach(function(el) { 
                el.classList.remove('accordion__item--active', 'accordion__item--animate');
                el.querySelector('.accordion__body').style.removeProperty("height");
            });
            el.classList.add('accordion__item--active', 'accordion__item--animate')
            body.style.height = 'auto';
            let height = body.offsetHeight + 'px';
            body.style.height = "0px";
            setTimeout(() => {
                body.style.height = height;
            }, 0);
        } else {
            el.classList.remove('accordion__item--animate');
            body.style.height = "0px";
            body.addEventListener('transitionend', () => {
                el.classList.remove('accordion__item--active');
            }, { once: true })
        }
    }

    document.querySelectorAll('.faq__sidebar-link').forEach(link => {
        link.addEventListener('click', function(){
            document.querySelector('.faq__sidebar-link--active').classList.remove('faq__sidebar-link--active');
            this.classList.add('faq__sidebar-link--active');
        })
    })
}, false);